import { Box, Button, Chip, Paper, Stack, Typography } from "@mui/material";
import React from "react";

import MedicalUxVersion from "../Types/MedicalUxVersion";

const experienceLabels: Record<MedicalUxVersion, string> = {
  [MedicalUxVersion.CombinedPage]: "All questions on one page"
};

export interface IMedicalWireframePickerProps {
  onSelect: (version: MedicalUxVersion) => void;
}

/** Inline selection card rendered in place of the medical step when no wireframe UX version has been chosen. */
const MedicalWireframePicker: React.FC<IMedicalWireframePickerProps> = ({ onSelect }) => (
  <Box display="flex" justifyContent="center" alignItems="center" height="100%">
    <Stack spacing={1.5} sx={{ maxWidth: 480, width: "100%" }}>
      <Paper
        elevation={0}
        sx={{
          px: 2,
          py: 1.5,
          backgroundColor: "warning.light",
          border: "1px dashed",
          borderColor: "warning.main",
          borderRadius: 1
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Chip label="PROTOTYPE" size="small" color="warning" sx={{ fontWeight: 700, letterSpacing: 1 }} />
          <Typography variant="caption" color="warning.dark" fontWeight={600}>
            This screen is not part of the production build. It is used for internal wireframe review only.
          </Typography>
        </Stack>
      </Paper>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Stack spacing={3}>
          <Typography variant="h6">Select a wireframe experience</Typography>
          <Typography variant="body2" color="text.secondary">
            Choose a layout to preview. Refreshing the page will return to this screen.
          </Typography>
          <Stack spacing={1}>
            {Object.values(MedicalUxVersion).map(version => (
              <Button key={version} variant="contained" fullWidth onClick={() => onSelect(version)}>
                {experienceLabels[version]}
              </Button>
            ))}
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  </Box>
);

export default MedicalWireframePicker;
